import React, { Component } from "react";
import { connect } from "react-redux";
import { disableUser, enableUser } from "../../actions/users";

import { BASE_URL } from "../../static/constants";
import getToken from "../../utils/getToken";

import Table from "./Table";
import { showErrorToast, showSuccessToast } from "utils/toast";

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: [],
      dataLoaded: false,
    };
    this.getUsers = this.getUsers.bind(this);
    this.enableUserSubmit = this.enableUserSubmit.bind(this);
    this.disableUserSubmit = this.disableUserSubmit.bind(this);
  }

  componentDidMount() {
    this.getUsers();
  }

  getUsers() {
    this.setState({
      dataLoaded: false,
    });
    fetch(`${BASE_URL}/admin/users`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.message) {
          throw Error(data.message);
        }

        this.setState({
          dataLoaded: true,
        });

        const userData = data.map((user) => {
          let accountString = "";
          user.accounts.forEach((account, i) => {
            const isComma = i !== user.accounts.length - 1;
            const commaHtml = isComma ? ", " : "";
            accountString += `${account}${commaHtml}`;
          });

          let manufacturerString = "";
          const manufacturerArr = user.manufacturer || [];
          if (manufacturerArr.length) {
            user.manufacturer.forEach((man, i) => {
              const isComma = i !== user.manufacturer.length - 1;
              const commaHtml = isComma ? ", " : "";
              manufacturerString += `${man}${commaHtml}`;
            });
          }

          let obj = {
            id: user._id,
            accounts: accountString,
            accountArr: user.accounts,
            manufacturer: manufacturerString,
            manufacturerArr,
            email: user.email,
            name: user.name,
            prevName: user.name,
            password: "",
            passwordConfirm: "",
            role: user.role,
            physician: user.physician || false,
            active: user.active,
            testUser: user.test_user || false,
            secondary_roles: user?.secondary_roles || [],
            is_auditor: user?.is_auditor || false,
            idp_user: user?.idp_user || false,
          };

          if (user?.show_HF_reports) {
            obj.showHFReports = user.show_HF_reports;
          }

          if (user?.show_regular_reports) {
            obj.showRegularReports = user.show_regular_reports;
          }

          if (user?.my_patients_toggled) {
            obj.myPatientsToggled = user.my_patients_toggled;
          }

          if (user?.isFollowingPhysician && user?.followingPhysicians) {
            obj.isFollowingPhysician = user.isFollowingPhysician;
            obj.physicians = user.followingPhysicians;
          }

          if (user?.isFollowingHospital && user?.followingHospitals) {
            obj.isFollowingHospital = user.isFollowingHospital;
            obj.hospitals = user.followingHospitals;
          }

          if (user?.clinii_user_id) {
            obj.clinii_user_id = user.clinii_user_id;
            obj.isCliniiUser = true;
          }

          return obj;
        });

        this.setState({
          userData,
        });
      })
      .catch((error) => {
        const errorStr = error.toString();
        if (errorStr === "Error: jwt malformed") {
          this.props.navigate("/login");
        }
        if (errorStr === "Error: jwt expired") {
          this.props.navigate("/login");
        }
        if (errorStr === "Error: Unauthorized") {
          this.props.navigate("/prohibited");
        }

        showErrorToast(errorStr);
      });
  }

  async disableUserSubmit(id) {
    const { userData } = this.state;
    await this.props.disableUser(id).then((response) => {
      const { data } = response;
      if (!data.error) {
        // needs to be moved to redux
        const userDataCopy = [...userData];
        const match = userDataCopy.find((user) => {
          return user.id === id;
        });
        match.active = false;
        this.setState({
          userData: userData,
        });
        showSuccessToast(data.message);
      }
    });
  }

  async enableUserSubmit(id) {
    const { userData } = this.state;
    await this.props.enableUser(id).then((response) => {
      const { data } = response;
      if (!data.error) {
        // needs to be moved to redux
        const userDataCopy = [...userData];
        const match = userDataCopy.find((user) => {
          return user.id === id;
        });
        match.active = true;
        this.setState({
          userData: userData,
        });
        showSuccessToast(data.message);
      }
    });
  }

  render() {
    const { userData, dataLoaded } = this.state;
    const userProps = {
      userData,
    };

    return (
      <div>
        {/* {!dataLoaded && (
          <div style={{ padding: "50px 0", textAlign: "center" }}>
            <LoadingSpinner />
          </div>
        )} */}
        {
          // dataLoaded && (
          <Table
            isLoading={!dataLoaded}
            userProps={userProps}
            getUsers={this.getUsers}
            enableUserSubmit={this.enableUserSubmit}
            disableUserSubmit={this.disableUserSubmit}
          />
          // )
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userDataRedux: state.users,
  };
};

export default connect(mapStateToProps, {
  disableUser,
  enableUser,
})(Users);
